import dayjs from 'dayjs'

export const checkTimeValidity = (date: string, time: string) => {
  const inputDateTime = dayjs.tz(`${date} ${time}`)
    .set('second', 0)
    .set('millisecond', 0)

  return inputDateTime.isAfter(dayjs.tz())
}
